export function isFakeLocation(
  location: uui.domain.client.FakeLocation | uui.domain.client.Location,
): location is uui.domain.client.FakeLocation {
  const loc = location as uui.domain.client.FakeLocation

  return !!loc.fakeLocation
}
